module.exports = __webpack_public_path__ + "img/diao_guan_ji-icon3.20cb73db.png";